import React from 'react';
import { cn } from '@/utils/cn';

interface CheckboxProps {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  disabled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  id,
  checked,
  onChange,
  className,
  disabled = false,
}) => {
  return (
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      disabled={disabled}
      className={cn(
        'h-4 w-4 text-blue-600 bg-white border-2 border-gray-300 rounded',
        'focus:ring-blue-500 focus:ring-2 focus:ring-offset-0',
        'checked:bg-blue-600 checked:border-blue-600',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'cursor-pointer',
        className
      )}
    />
  );
};